module.exports = __webpack_public_path__ + "static/media/lamppost-media.ed674fd0.png";